export default "__VITE_ASSET__5rNWbCVn__"